// Story 7-FU-C (ADO-1216): the web allow-list mirrors the backend
// `BROWSE_PAGE_SIZE_OPTIONS`, which rejects any other page size.
export const BROWSE_PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const;
export const DEFAULT_BROWSE_PAGE_SIZE = 20;
